class PixelEventsHook {
    static events = {};
    fbq_events_activated = ["all"];
    ttq_events_activated = ["all"];
    constructor(event_name, application, data = {}) {
        this.fbq_events_activated = window.fbq_events_activated ?? ["all"];
        this.ttq_events_activated = window.ttq_events_activated ?? ["all"];

        function wasSentEvent(){
            try {
                if(typeof PixelEventsHook.events[application] === "undefined"){
                    PixelEventsHook.events[application] = {};
                }
    
                let event = PixelEventsHook.events[application][event_name] ?? false;
                if(event){
                    console.log("PixelEventsHook: Event already sent");
                    return true;
                }
    
                PixelEventsHook.events[application][event_name] = true;
                return false;
            } catch (error) {
                console.log("PixelEventsHook: Error on tracking event");
                console.error(error);
                return false;
            }
        }

        try {
            if(application === "facebook_pixel" || application === "fbq"){
                if(typeof window.fbq !== "function"){return;}
                if(this.fbq_events_activated.includes("all") || this.fbq_events_activated.includes(event_name)){
                    let wasSent = wasSentEvent();
                    if(wasSent){return;}
                    window.fbq('track', event_name, data);
                    console.table({
                        "PixelEventsHook: Tracking event": event_name,
                        "Application": application,
                        "Data": data
                    });
                }
            }
    
            if(application === "tiktok_pixel" || application === "ttq"){
                if(typeof window.ttq !== "function"){return;}
                if(this.ttq_events_activated.includes("all") || this.ttq_events_activated.includes(event_name)){
                    let wasSent = wasSentEvent();
                    if(wasSent){return;}
                    window.ttq.track(event_name, data);
                    console.table({
                        "PixelEventsHook: Tracking event": event_name,
                        "Application": application,
                        "Data": data
                    });
                }
            }
        } catch (error) {
            console.log("PixelEventsHook: Error on tracking event");
            console.error(error);
        }
    }
}


export default PixelEventsHook;